import {
  Tr,
  Td,
  Flex,
  Text,
  Button,
  Badge,
  HStack,
  useColorModeValue,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure
} from "@chakra-ui/react";
import React, { useState } from "react";
import scheduleService from "services/report/scheduleService";
import CetakST from "views/pdf/ModalST";
import ModalST from "./modalCreateST";

const JadwalRow = ({
  id,
  pemohon,
  alamat,
  nm_upi,
  prop,
  kota,
  produk = [],
  tanggal,
  jenis_izin,
  kode_status,
  status,
  personil = [],
  refreshData
}) => {
  const textColor = useColorModeValue("gray.700", "white");
  const subColor = useColorModeValue("gray.400", "gray.300");
  const toast = useToast();
  const role = localStorage.getItem("role");

  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [openCetak, setOpenCetak] = useState(false);
 
  const confirmModal = useDisclosure();
  const createModal = useDisclosure();
  const cancelRef = React.useRef();

  /* =========================
     ACTION HANDLER
  ========================== */
  const handleConfirmAction = async () => {
    setLoading(true);
    try {
      if (actionType === "PROSES_KATIM") {
        await scheduleService.prosesKatim(id);
      }
      if (actionType === "APPROVE_KATIM") {
        await scheduleService.approveKatim(id);
      }
      if (actionType === "APPROVE_KEPALA") {
        await scheduleService.approveKepala(id);
      }

      toast({ title: "Berhasil diproses", status: "success" });
      refreshData();
    } catch (err) {
      toast({ title: "Terjadi kesalahan", status: "error" });
    } finally {
      setLoading(false);
      confirmModal.onClose();
    }
  };

  const renderActionRoleSespri = () => {
    if (kode_status === 1)
      return actionButton("Ajukan Jadwal", "purple", "PROSES_KATIM");

    if (kode_status === 2)
      return actionButton("Proses", "orange", "APPROVE_KATIM");

    if (kode_status === 3)
      return actionButton("Proses", "blue", "APPROVE_KEPALA");

    if (kode_status === 5)
      return (
        <Button size="sm" colorScheme="green" onClick={() => {
          setSelectedId(id);
          createModal.onOpen();
        }}>
          Buat Surat
        </Button>
      );

    if (kode_status === 6) {
      return (
        <HStack spacing={2}>
          <Button 
            size="sm" 
            variant="outline" 
            colorScheme="blue" 
            onClick={() => {
              setSelectedId(id); 
              setOpenCetak(true);
            }}
          >
            Surat Tugas
          </Button>
          <Button size="sm" variant="outline" colorScheme="teal">
            SPPD
          </Button>
        </HStack>
      );
    }
    return <Text fontSize="xs" color="gray.400">Menunggu Proses</Text>;
  };

  const actionButton = (label, color, type) => (
    <Button
      size="sm"
      colorScheme={color}
      onClick={() => {
        setActionType(type);
        confirmModal.onOpen();
      }}
    >
      {label}
    </Button>
  );

  /* =========================
     ACTION HANDLER TER-UPDATE
  ========================== */
  const renderAction = () => {
    const isSuperAdmin = role === "1";
    if (kode_status === 1) {
      if (role === "5" || isSuperAdmin) {
        return actionButton("Ajukan Jadwal", "purple", "PROSES_KATIM");
      }
    }

    if (kode_status === 2) {
      if (role === "3" || isSuperAdmin) {
        return (
          <HStack spacing={2}>
            {actionButton("Setujui", "green", "APPROVE_KATIM")}
            
            <Button 
              size="sm" 
              colorScheme="red" 
              variant="outline"
              onClick={() => {
                setActionType("REJECT_KATIM"); 
                confirmModal.onOpen();
              }}
            >
              Tolak
            </Button>
          </HStack>
        );
      }
    }

    // KODE STATUS 3: Hanya Role 2 (atau Role 1)
    if (kode_status === 3) {
      if (role === "2" || isSuperAdmin) {
        return actionButton("Setujui Kepala", "blue", "APPROVE_KEPALA");
      }
    }

    // KODE STATUS 5: Buat Surat (Biasanya Role Admin/Sespri)
    if (kode_status === 5) {
      if (role === "4" || isSuperAdmin) {
        return (
          <Button size="sm" colorScheme="green" onClick={() => {
            setSelectedId(id);
            createModal.onOpen();
          }}>
            Buat Surat
          </Button>
        );
      }
    }

    // KODE STATUS 6: Hanya Role 4 (atau Role 1)
    if (kode_status === 6) {
      return (
        <HStack spacing={2}>
          <Button 
            size="sm" 
            variant="outline" 
            colorScheme="blue" 
            onClick={() => {
              setSelectedId(id); 
              setOpenCetak(true);
            }}
          >
            Surat Tugas
          </Button>
          <Button size="sm" variant="outline" colorScheme="teal">
            SPPD
          </Button>
        </HStack>
      );
    }
    return <Text fontSize="xs" color="gray.400">Menunggu Proses</Text>;
  };

  /* =========================
     RENDER
  ========================== */
  return (
    <>
      <Tr>
        {/* PETUGAS */}
        <Td minWidth="250px">
          {personil.map((p, i) => (
            <Flex key={i} direction="column" mb={2}>
              <Text fontWeight="bold" color={textColor}>{p.NAMA}</Text>
              <Text fontSize="sm" color={subColor}>{p.NIP}</Text>
            </Flex>
          ))}
        </Td>

        {/* TUJUAN */}
        <Td>
          <Text fontWeight="bold">{nm_upi}</Text>
          <Text fontSize="sm" color={subColor}>{alamat}</Text>
          <Text fontSize="sm" color={subColor}>{prop} ({kota})</Text>
        </Td>

        {/* PRODUK */}
        <Td>
          {produk.map((r, i) => (
            <Text key={i} fontWeight="bold">
              {r.nama_produk} ({r.grade})
            </Text>
          ))}
        </Td>

        {/* TANGGAL */}
        <Td>
          <Text fontWeight="bold">{tanggal}</Text>
        </Td>

        {/* STATUS */}
        <Td>
          <Badge colorScheme={kode_status <= 2 ? "orange" : kode_status === 3 ? "blue" : kode_status === 5 ? "green" : "purple"}>
            {status?.nm_sts}
          </Badge>
        </Td>

        {/* AKSI */}
        <Td>{renderAction()}</Td>
      </Tr>

      {/* MODAL CREATE ST */}
      <ModalST
        isOpen={createModal.isOpen}
        onClose={createModal.onClose}
        sourceId={selectedId}
        onSuccess={() => {
          createModal.onClose();
          refreshData();
        }}
      />

      {/* MODAL PDF */}
      <CetakST
        isOpen={openCetak}
        onClose={() => setOpenCetak(false)}
        sourceId={id}
        docType={jenis_izin} 
      />

      {/* ALERT KONFIRMASI */}
      <AlertDialog
        isOpen={confirmModal.isOpen}
        leastDestructiveRef={cancelRef}
        onClose={confirmModal.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Konfirmasi</AlertDialogHeader>
            <AlertDialogBody>Apakah Anda yakin?</AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={confirmModal.onClose}>Tidak</Button>
              <Button colorScheme="red" ml={3} isLoading={loading} onClick={handleConfirmAction}>
                Iya
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default JadwalRow;
